import React from 'react';

import { useCheckDeletionEmployeeUserQuery, useDeleteEmployeeUserMutation } from 'src/api';
import { useNotification } from 'src/hooks/app';
import { DeleteConfirmationModal } from 'src/modals/common';
import { ModalV2Props } from 'src/types/modalV2';

type DeleteEmployeeUserConfirmationModalProps = {
  employeeId: string;
  onDeleted?: () => void;
};

export const DeleteEmployeeUserConfirmationModal: React.FC<
  ModalV2Props<DeleteEmployeeUserConfirmationModalProps>
> = ({ id, employeeId, onDeleted }) => {
  const { createApolloContext } = useNotification();

  const { data, loading } = useCheckDeletionEmployeeUserQuery({
    variables: { employeeId },
    fetchPolicy: 'network-only',
  });

  const [deleteEmployeeUser, { loading: deleteLoading }] = useDeleteEmployeeUserMutation({
    context: createApolloContext({ successMessage: 'Successfully deleted' }),
  });

  const handleConfirm = React.useCallback(
    () => deleteEmployeeUser({ variables: { employeeId } }),
    [deleteEmployeeUser, employeeId],
  );

  return (
    <DeleteConfirmationModal
      id={id}
      entityName="Employee user"
      description="You want to delete this employee’s user account? Employee and employment data will be kept."
      check={data?.checkDeletionEmployeeUser}
      loading={loading}
      deleteLoading={deleteLoading}
      onConfirm={handleConfirm}
      onDeleted={onDeleted}
    />
  );
};
